import React, { useState } from 'react';
import { useCurrency } from '../context/CurrencyContext';
import './HelpCenter.css';

const HelpCenter = () => {
  const { currency } = useCurrency();
  const [activeCategory, setActiveCategory] = useState('general');

  // Function to get currency symbol
  const getCurrencySymbol = () => {
    if (currency === '$') return '$';
    else if (currency === '£') return '£';
    else if (currency === 'AED') return 'د.إ';
    else if (currency === 'KSA') return 'ر.س';
    return '£'; // Default fallback
  };

  const faqData = {
    general: [
      {
        question: "How do I create an account?",
        answer: "You can create an account by clicking the 'Sign Up' button in the top navigation. You'll need to provide your email address and create a password."
      },
      {
        question: "How do I reset my password?",
        answer: "Click on 'Forgot Password' on the login page. Enter your email address and we'll send you a link to reset your password."
      },
      {
        question: "Can I change my email address?",
        answer: "Yes, you can update your email address in your account settings. Go to your profile and click on 'Edit Account Information'."
      }
    ],
    orders: [
      {
        question: "How do I track my order?",
        answer: "Once your order ships, you'll receive a tracking number via email. You can also check your order status in your account dashboard."
      },
      {
        question: "Can I cancel my order?",
        answer: "Orders can be cancelled within 1 hour of placement. Contact our customer service team immediately if you need to cancel an order."
      },
      {
        question: "What payment methods do you accept?",
        answer: "We accept all major credit cards (Visa, MasterCard, American Express), PayPal, and Apple Pay."
      }
    ],
    returns: [
      {
        question: "What is your return policy?",
        answer: "We accept returns within 30 days of delivery for most items. Items must be in their original condition with all tags attached."
      },
      {
        question: "How do I start a return?",
        answer: "Go to your order history, select the item you want to return, and click 'Start Return'. Follow the instructions to print a return label."
      },
      {
        question: "When will I get my refund?",
        answer: "Refunds are processed within 5-7 business days of receiving your returned item. The refund will be issued to your original payment method."
      }
    ],
    shipping: [
      {
        question: "How long does shipping take?",
        answer: "Standard shipping takes 3-5 business days. Express shipping takes 1-2 business days. International shipping takes 7-14 business days."
      },
      {
        question: "Do you ship internationally?",
        answer: "Yes, we ship to most countries. Shipping costs and delivery times vary by location. Check our shipping calculator for specific rates."
      },
      {
        question: "Is shipping free?",
        answer: `Free shipping is available on orders over ${getCurrencySymbol()}50. For orders under ${getCurrencySymbol()}50, standard shipping costs ${getCurrencySymbol()}5.99.`
      }
    ]
  };

  const categories = [
    { id: 'general', name: 'General', icon: '❓' },
    { id: 'orders', name: 'Orders', icon: '📦' },
    { id: 'returns', name: 'Returns', icon: '🔄' },
    { id: 'shipping', name: 'Shipping', icon: '🚚' }
  ];

  return (
    <div className="help-page">
      {/* Hero Section */}
      <div className="help-hero">
        <div className="help-hero-content">
          <h1>Help Center</h1>
          <p>Find answers to your questions and get the support you need</p>
        </div>
      </div>

      <div className="help-container">
        <div className="help-content">
          {/* Category Navigation */}
          <div className="category-nav">
            {categories.map(category => (
              <button
                key={category.id}
                className={`category-btn ${activeCategory === category.id ? 'active' : ''}`}
                onClick={() => setActiveCategory(category.id)}
              >
                <span className="category-icon">{category.icon}</span>
                <span className="category-name">{category.name}</span>
              </button>
            ))}
          </div>

          {/* FAQ Section */}
          <div className="faq-section">
            <h2>{categories.find(cat => cat.id === activeCategory)?.name} Questions</h2>
            <div className="faq-list">
              {faqData[activeCategory].map((faq, index) => (
                <div key={index} className="faq-item">
                  <h3 className="faq-question">{faq.question}</h3>
                  <p className="faq-answer">{faq.answer}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Contact Section */}
          <div className="contact-section">
            <h2>Still Need Help?</h2>
            <p>Can't find what you're looking for? Our customer service team is here to help!</p>
            <div className="contact-methods">
              <div className="contact-method">
                <div className="method-icon">📧</div>
                <div className="method-info">
                  <h3>Email Support</h3>
                  <p>support@inifiy.com</p>
                  <span>Response within 24 hours</span>
                </div>
              </div>
              <div className="contact-method">
                <div className="method-icon">📞</div>
                <div className="method-info">
                  <h3>Phone Support</h3>
                  <p>+1 (555) 123-4567</p>
                  <span>Mon-Fri, 9AM-6PM EST</span>
                </div>
              </div>
              <div className="contact-method">
                <div className="method-icon">💬</div>
                <div className="method-info">
                  <h3>Live Chat</h3>
                  <p>Available on our website</p>
                  <span>Instant response</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HelpCenter; 